<script setup lang="ts">
defineOptions({ inheritAttrs: false });

import { computed } from "vue";
import { useStore } from "@/stores";

const props = defineProps<{ modelValue?: string; height?: number }>();

const images = computed(() =>
  props.modelValue ? props.modelValue.split(",") : []
);

const swiperHeight = computed(() => (props.height ? props.height : "auto"));

const { uploadDirectory } = useStore();
</script>
<template>
  <nut-swiper v-bind="$attrs" :height="swiperHeight">
    <nut-swiper-item v-for="(item, index) in images" :key="index">
      <nut-image :src="`${uploadDirectory}/${item}`" fit="fill" width="100%" />
    </nut-swiper-item>
  </nut-swiper>
</template>
<style lang="scss">
.nut-swiper {
  width: 100%;
}

.nut-swiper-item img {
  width: 100%;
  height: 100%;
}
</style>
